export default {
  currencies: [
    'EUR',
    'GBP',
    'USD',
    'ZAR',
  ],
  selectedCurrency: 'EUR',
};
